import { FilledLinkToWebField } from '@prismicio/client';
import { ITitleTextButton, TitleTextButtonProps } from './types';

export const mapTitleTextButton = ({
  prismicContent: { primary },
}: {
  prismicContent: TitleTextButtonProps['slice'];
}): ITitleTextButton => {
  const {
    button_label: buttonLabel,
    internal_link: internalLink,
    external_link: externalLink,
    white_background: whiteBackground,
  } = primary;

  return {
    ...primary,
    buttonLabel: buttonLabel as string,
    link: internalLink || (externalLink as FilledLinkToWebField).url,
    whiteBackground,
  };
};
